import imageUrl from "@/utils/imageUrl";
import { Form, Input } from "antd";
import classNames from "classnames";
import { forwardRef, useCallback, useState } from "react";
import { When } from "react-if";
import styles from "./index.module.less";
import PinCreatorLabelSelect from "./PinCreatorLabelSelect";

const { TextArea } = Input;
/**
 * @param {{
 *  pin?: IPin;
 *  imgData?: import("./SinglePinCreator").SinglePinCreatorProps["imageData"];
 * }} props
 *  pin :  通过已有采集进行采集
 *  imgData： 通过图片上传采集
 */
function PinCreatorInfo({ pin, imgData }, ref) {
  const [placeholderVisible, setPlaceholderVisible] = useState(true);

  const onImgLoad = useCallback(() => {
    setPlaceholderVisible(false);
  }, []);

  return (
    <div className={styles.info}>
      <div
        className={classNames([
          styles.img,
          placeholderVisible ? styles.hide : null,
        ])}
      >
        <img
          className="transparent-img-bg"
          src={imgData ? imgData.base64 : imageUrl(pin?.file, { width: 220 })}
          alt={imgData ? imgData?.description : pin?.raw_text}
          onLoad={onImgLoad}
        />
      </div>
      <When condition={pin || imgData}>
        <Form className={styles.form} ref={ref}>
          <Form.Item
            name="text"
            initialValue={imgData?.description || pin?.raw_text}
          >
            <TextArea
              className={styles.input}
              placeholder="添加描述"
              maxLength={255}
            />
          </Form.Item>
          <Form.Item name="tags" initialValue={imgData?.tags?.split(",")}>
            <PinCreatorLabelSelect pin={pin} />
          </Form.Item>
        </Form>
      </When>
    </div>
  );
}

export default forwardRef(PinCreatorInfo);
